import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ShiftWarningTooltipComponent } from './shift-warning-tooltip.component';

@Component({
  selector: 'shift-warning',
  templateUrl: './shift-warning.component.html',
  imports: [TranslatePipe, ShiftWarningTooltipComponent],
})
export class ShiftWarningComponent {
  @Input()
  absenceWarning: boolean;
  @Input()
  doubleRegistration: boolean;
  @Input()
  deviatesFromSchedule: boolean;
}
